import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { KeyboardNavigationService } from './services/keyboard-navigation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  constructor(
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private ga: GoogleAnalyticsService,
    private keyboardNavigationService: KeyboardNavigationService
  ) {
    translate.setDefaultLang('en');
    translate.use('en');
  }

  ngOnInit() {
    this.ga.sendEvent(
      'loading',
      'page',
      'ART initial application loaded DateTime',
      new Date().getTime()
    );

    this.keyboardNavigationService.init();
    // setting titles for each page
    this.router.events.pipe(
      takeUntil(this.destroy$)
    ).subscribe(event => {
      if (event instanceof NavigationEnd) {
        let route = this.activatedRoute;
        while (route.firstChild) { route = route.firstChild; }
        const titleKey = route.snapshot.data['title'] || 'page.title.default';
        this.translate.get(titleKey).pipe(take(1)).subscribe((title: string) => {
          this.titleService.setTitle(title);
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
